export const IDENTITY_POINT_ERROR_TEXT =
  'requires 100 points of ID (e.g. a Driver Licence and an appropriate supporting ID document).'
export const IDENTITY_POINT_TOAST_ERROR =
  'This agency requires 100 points of ID'
export const IDENTITY_POINT_THRESHOLD_VALUE = 100

export const ONE_PRIMARY_IDENTITY_ERROR_TEXT =
  'requires one primary ID document (e.g. a Driver Licence or Passport)'

export const TWO_IDENTITY_ERROR_TEXT =
  'requires two ID documents (e.g. a primary and a secondary)'

export const identityCapEnabledNumberOptions = [
  { value: 0, label: '100 points' },
  { value: 1, label: 'One Primary ID' },
  { value: 2, label: 'Two ID (e.g. Primary & Secondary)' },
]

export const HUNDRED_POINTS_OPTION_VALUE_STRING = '0'
export const ONE_PRIMARY_ID_OPTION_VALUE_STRING = '1'
export const TWO_ID_OPTION_VALUE_STRING = '2'

export const identityCapEnabledNumberOptionsMap = {
  0: '100 points',
  1: 'One Primary ID',
  2: 'two ID documents (e.g. a primary and a secondary)',
}

export const identityCapEnabledNumberOptionsErrorMap = {
  0: IDENTITY_POINT_ERROR_TEXT,
  1: ONE_PRIMARY_IDENTITY_ERROR_TEXT,
  2: TWO_IDENTITY_ERROR_TEXT,
}

export const NUMBER_OF_IDS_REQUIRED = 1
export const NUMBER_OF_TWO_IDS_REQUIRED = 2

export const payslipsRequiredNumberOptions = [
  { value: 0, label: 'Three' },
  { value: 1, label: 'Two' },
  { value: 2, label: 'One' },
]

export const payslipReqOptions = {
  0: 3,
  1: 2,
  2: 1,
}

export const requireBankStatementOptions = [
  { value: 0, label: 'Bank Statement' },
  { value: 1, label: 'Bank Statement (Transactions)' },
  { value: 2, label: 'Bank Statement (Balance)' },
  { value: 3, label: 'No Bank Statement' },
]

export const requireBankStatementOptionsMap = {
  0: '',
  1: ' (with Transactions)',
  2: ' (with Balance)',
  3: ' (Not Required)',
}

export const requireBankStatementTypeOptions = [
  { value: 0, label: 'Two Years' },
  { value: 1, label: 'Most recent two' },
]

export const requireBankStatementTypeOptionsMap = {
  0: 'Two Years',
  1: 'Most recent two',
}
